<template>
  <v-menu
    ref="datepickerMenu"
    v-model="datepickerMenu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="dateFormatted"
        :label="label"
        :hint="hint"
        persistent-hint
        prepend-icon="event"
        v-bind="attrs"
        @blur="date = parseDate(dateFormatted)"
        v-on="on"
        :rules="datepickerRules"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="date"
      :min="min"
      :locale="$i18n.locale"
      :first-day-of-week="firstDayOfWeek($i18n.locale)"
      no-title
      @input="datepickerMenu = false"
    ></v-date-picker>
  </v-menu>
</template>

<script>
import moment from 'moment'

import { firstDayOfWeek } from '@/script/dateAndHour'

export default {
  name: 'DatepickerOfRoom',

  props: {
    label: String,
    hint: String,
    value: String
  },

  data: vm => ({
    date: null,
    dateFormatted: null,
    datepickerMenu: false,
    min: moment().format('YYYY-MM-DD'),
    datepickerRules: [
      v => !!v || vm.$t('rooms.form.required'),
      v => (v && moment(v, 'DD/MM/YYYY', true).isValid()) || vm.$t('rooms.form.invalidFormatDate'),
      v => {
        if (v) {
          const [day, month, year] = v.split('/')
          const [year2, month2, day2] = moment()
            .format('YYYY/MM/DD')
            .split('/')

          const a = moment([year, month, day])
          const b = moment([year2, month2, day2])

          const res = a.diff(b, 'days')

          if (res < 0) {
            return vm.$t('rooms.form.invalidFormatDate')
          } else {
            return true
          }
        } else {
          return true
        }
      }
    ]
  }),

  created() {
    this.date = this.value
  },

  watch: {
    date(value) {
      this.dateFormatted = this.formatDate(this.date)
      this.$emit('save-date', { name: 'date', value: value })
    }
  },

  methods: {
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    parseDate(date) {
      if (!date) return null

      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    firstDayOfWeek(locale) {
      return firstDayOfWeek(locale)
    }
  }
}
</script>
